import { Link, NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  Activity, BookOpen, Boxes, FileText, Layers, Moon, Server, Settings, Sun, Zap,
} from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import neubirdMarkLight from "@/assets/neubird-mark-light.svg";
import neubirdMarkDark from "@/assets/neubird-mark-dark.svg";

const TABS = [
  // Suites above Runs: a batch is the usual way work is started now, and a
  // single run is the exception rather than the entry point.
  { to: "/suites", label: "Suites", icon: Layers },
  { to: "/runs", label: "Runs", icon: Activity },
  { to: "/scenarios", label: "Scenarios", icon: FileText },
  { to: "/runners", label: "Runners", icon: Server },
  { to: "/backends", label: "Backends", icon: Boxes },
  { to: "/templates", label: "Templates", icon: Zap },
  { to: "/docs", label: "Docs", icon: BookOpen },
  { to: "/settings", label: "Settings", icon: Settings },
];

export function Sidebar() {
  const { theme, toggle } = useTheme();
  return (
    <aside className="w-56 border-r border-border bg-card flex-shrink-0 flex flex-col">
      <Link
        to="/"
        className="px-4 py-6 border-b border-border flex items-center gap-2.5 hover:bg-muted/40 transition-colors"
      >
        <img
          src={theme === "dark" ? neubirdMarkDark : neubirdMarkLight}
          alt=""
          aria-hidden
          className="w-10 h-8 flex-shrink-0 object-contain"
        />
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-foreground">demosim</h1>
          <p className="text-xs text-muted-foreground">NeuBird agent runner</p>
        </div>
      </Link>
      <nav className="p-2 space-y-1 flex-1">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors",
                  isActive
                    ? "bg-accent text-accent-foreground"
                    : "text-foreground hover:bg-muted",
                )
              }
            >
              <Icon size={16} />
              {tab.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-2 border-t border-border">
        <button
          type="button"
          onClick={toggle}
          aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground hover:bg-muted transition-colors"
        >
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          {theme === "dark" ? "Light mode" : "Dark mode"}
        </button>
      </div>
    </aside>
  );
}
